/** The shell's empty frame: the rail and the top bar, drawn from `tokens.css` and nothing else.
 *
 * `index.html` carries the same two elements inside `#root`, so a first paint is the teal rail and the
 * white bar rather than a white page for as long as the first `/auth/me` is in flight (measured 1.8s
 * on a fresh load of the heavy workspace). React replaces that markup when it mounts, and
 * `RequireSession` rendered `null` for the moment after, which blanked it again; this component is
 * what it renders instead, so the frame holds from the first byte until the real shell is drawn.
 *
 * Decoration only: hidden from assistive technology, no text, no motion. The classes are global and
 * live in `tokens.css` because the markup in `index.html` is outside React and CSS modules.
 */
export function BootFrame() {
  return (
    <div className="bootShell" aria-hidden="true" data-testid="boot-frame">
      <div className="bootRail" />
      <div className="bootTop" />
    </div>
  );
}
